var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticStyle:{"margin":"5px 0 5px 10px"},attrs:{"type":"autotype_Relevance","size":"mini","disabled":_vm.disabledRelevance},nativeOn:{"click":function($event){return _vm.onRelevance()}}},[_vm._v(_vm._s(_vm.auto_str_Relevance))])
}
var staticRenderFns = []

export { render, staticRenderFns }